import { LinkProps } from 'src/models'

const rootDataLayer = {
  category: 'Clique',
  action: 'Footer'
}

export const products: LinkProps[] = [
  {
    id: 1,
    link: '/emprestimo-com-garantia-de-imovel',
    label: 'Empréstimo com Garantia de Imóvel',
    dataLayer: {
      ...rootDataLayer,
      label: 'Para você - Link Empréstimo com Garantia de Imóvel'
    }
  },
  {
    id: 2,
    link: '/financiamento-imobiliario',
    label: 'Financiamento Imobiliário SFI',
    dataLayer: {
      ...rootDataLayer,
      label: 'Para você - Link Financiamento Imobiliário SFI'
    }
  },
  {
    id: 3,
    link: '/home-equity',
    label: 'Home Equity',
    dataLayer: {
      ...rootDataLayer,
      label: 'Para você - Link Home Equity'
    }
  },
  {
    id: 4,
    link: '/condo',
    label: 'Empréstimo para Condomínio',
    dataLayer: {
      ...rootDataLayer,
      label: 'Para seu condominio - Link Empréstimo para Condomínio'
    }
  }
]

export const moreProducts: LinkProps[] = [
  {
    id: 1,
    link: '/emprestimo-para-reforma',
    label: 'Empréstimo para Reforma',
    dataLayer: {
      ...rootDataLayer,
      label: 'Como podemos te ajudar - Link Empréstimo para Reforma'
    }
  },
  {
    id: 2,
    link: '/financiamento-para-construcao',
    label: 'Financiamento para Construção',
    dataLayer: {
      ...rootDataLayer,
      label: 'Como podemos te ajudar - Link Financiamento para Construção'
    }
  },
  {
    id: 3,
    link: '/portabilidade-de-dividas',
    label: 'Portabilidade de Dívidas',
    dataLayer: {
      ...rootDataLayer,
      label: 'Como podemos te ajudar - Link Portabilidade de Dívidas'
    }
  },
  {
    id: 4,
    link: '/emprestimo-para-empresa',
    label: 'Empréstimo para Empresas',
    dataLayer: {
      ...rootDataLayer,
      label: 'Como podemos te ajudar - Link Empréstimo para Empresas'
    }
  },
  {
    id: 5,
    link: '/financiamento-energia-solar',
    label: 'Financiamento de Energia Solar',
    dataLayer: {
      ...rootDataLayer,
      label: 'Como podemos te ajudar - Link Financiamento de Energia Solar'
    }
  },
  {
    id: 6,
    link: '/emprestimo-para-capital-de-giro',
    label: 'Empréstimo para Capital de Giro',
    dataLayer: {
      ...rootDataLayer,
      label: 'Como podemos te ajudar - Link Empréstimo para Capital de Giro'
    }
  },
  {
    id: 7,
    link: '/emprestimo-com-garantia-de-terreno',
    label: 'Empréstimo com Garantia de Terreno',
    dataLayer: {
      ...rootDataLayer,
      label: 'Como podemos te ajudar - Link Empréstimo com Garantia de Terreno'
    }
  }
]

export const calculators: LinkProps[] = [
  {
    id: 1,
    link: 'https://www.cashme.com.br/blog/calculadoras/juros-compostos/',
    label: 'Juros Compostos',
    dataLayer: {
      ...rootDataLayer,
      label: 'Calculadoras - Link Juros Compostos'
    }
  },
  {
    id: 2,
    link: 'https://www.cashme.com.br/blog/calculadoras/salario-liquido/',
    label: 'Salário Líquido',
    dataLayer: {
      ...rootDataLayer,
      label: 'Calculadoras - Link Salário Líquido'
    }
  },
  {
    id: 3,
    link: 'https://www.cashme.com.br/blog/calculadoras/decimo-terceiro/',
    label: 'Décimo Terceiro Salário',
    dataLayer: {
      ...rootDataLayer,
      label: 'Calculadoras - Link Décimo Terceiro Salário'
    }
  },
  {
    id: 4,
    link: 'https://www.cashme.com.br/blog/calculadoras/capital-de-giro/',
    label: 'Capital de Giro',
    dataLayer: {
      ...rootDataLayer,
      label: 'Calculadoras - Link Capital de Giro'
    }
  },
  {
    id: 5,
    link: 'https://www.cashme.com.br/blog/calculadoras/rescisao/',
    label: 'Rescisão de CLT',
    dataLayer: {
      ...rootDataLayer,
      label: 'Calculadoras - Link Rescisão de CLT'
    }
  },
  {
    id: 6,
    link: 'https://www.cashme.com.br/blog/calculadoras/rendimento-poupanca/',
    label: 'Rendimento da Poupança',
    dataLayer: {
      ...rootDataLayer,
      label: 'Calculadoras - Link Rendimento da Poupança'
    }
  }
]

export const otherProducts: LinkProps[] = [
  {
    id: 1,
    link: '/emprestimo-online',
    label: 'Empréstimo Online',
    dataLayer: {
      ...rootDataLayer,
      label: 'Veja também - Link Empréstimo Online'
    }
  },
  {
    id: 2,
    link: '/simulacao-de-emprestimo',
    label: 'Simulação de Empréstimo',
    dataLayer: {
      ...rootDataLayer,
      label: 'Veja também - Link Simulação de Empréstimo'
    }
  },
  {
    id: 3,
    link: '/emprestimo-para-autonomo',
    label: 'Empréstimo para Autônomo',
    dataLayer: {
      ...rootDataLayer,
      label: 'Veja também - Link Empréstimo para Autônomo'
    }
  }
]

export const cashme: LinkProps[] = [
  {
    id: 1,
    link: '/',
    label: 'Home',
    dataLayer: {
      ...rootDataLayer,
      label: 'A CashMe - Link Home'
    }
  },
  {
    id: 2,
    link: '/quem-somos',
    label: 'Sobre a Cashme',
    dataLayer: {
      ...rootDataLayer,
      label: 'A CashMe - Link Sobre a Cashme'
    }
  },
  {
    id: 3,
    link: 'https://www.cashme.com.br/blog/',
    label: 'Blog',
    dataLayer: {
      ...rootDataLayer,
      label: 'A CashMe - Link Blog'
    }
  },
  {
    id: 4,
    link: '/seguranca',
    label: 'Segurança',
    dataLayer: {
      ...rootDataLayer,
      label: 'A CashMe - Link Segurança'
    }
  },
  {
    id: 5,
    link: 'https://www.cashme.com.br/construcast/',
    label: 'Construcast',
    dataLayer: {
      ...rootDataLayer,
      label: 'A CashMe - Link Construcast'
    }
  },
  {
    id: 6,
    link: '/aviso-de-privacidade',
    label: 'Aviso de Privacidade',
    dataLayer: {
      ...rootDataLayer,
      label: 'A CashMe - Link Aviso de Privacidade'
    }
  },
  {
    id: 7,
    link: 'https://contatoseguro.com.br/cashme/',
    label: 'Canal de Denúncias',
    dataLayer: {
      ...rootDataLayer,
      label: 'A CashMe - Link Canal de Denúncias'
    }
  },
  {
    id: 8,
    link: '/relacoes-com-investidores',
    label: 'Relações com Investidores',
    dataLayer: {
      ...rootDataLayer,
      label: 'A CashMe - Link Relações com Investidores'
    }
  },
  {
    id: 9,
    link: 'https://www.cashme.com.br/blog/glossario/',
    label: 'Glossário',
    dataLayer: {
      ...rootDataLayer,
      label: 'A CashMe - Link Glossário'
    }
  }
]

export const partners: LinkProps[] = [
  {
    id: 1,
    link: '/seja-um-parceiro',
    label: 'Seja um Parceiro',
    dataLayer: {
      ...rootDataLayer,
      label: 'Parceiros CashMe - Seja um Parceiro'
    }
  },
  {
    id: 2,
    link: 'https://institucional.cashme.com.br/cashmember',
    label: 'Portal CashMember',
    dataLayer: {
      ...rootDataLayer,
      label: 'Parceiros CashMe - Portal CashMember'
    }
  }
]

export const help: LinkProps[] = [
  {
    id: 1,
    link: 'https://www.cashme.com.br/documentos/pdf/250714/CashMe_Biblioteca_Documentos.pdf',
    label: 'Biblioteca de documentos',
    dataLayer: {
      ...rootDataLayer,
      label: 'Precisa de ajuda - Link Biblioteca de documentos'
    }
  },
  {
    id: 2,
    link: '/ajuda',
    label: 'Perguntas Frequentes',
    dataLayer: {
      ...rootDataLayer,
      label: 'Precisa de ajuda - Link Perguntas Frequentes'
    }
  },
  {
    id: 3,
    link: '/sou-cliente',
    label: '2º via de boleto',
    dataLayer: {
      ...rootDataLayer,
      label: 'Precisa de ajuda - Link 2º via de boleto'
    }
  }
]
